import React from 'react';

import { Text } from '@/components/TextComponent';

export const ActionButton = ({ onPress, buttonText }: { onPress: () => void; buttonText: string }) => {
    return (
        <Text textDecorationLine="underline" fontWeight="bold" variant="bodySmall" onPress={onPress}>
            {buttonText}
        </Text>
    );
};
